import {combineReducers}        from '@reduxjs/toolkit'
import { bomApi }               from 'src/services/rtk_api/bom/BomApi';
import { authApi }              from 'src/services/rtk_api/auth/authApi';
import { cartApi }              from 'src/services/rtk_api/order/CartApi';
import { checkoutApi }          from 'src/services/rtk_api/order/CheckoutApi';
import { productApi }           from 'src/services/rtk_api/product/ProductApi';
import { sessionApi }           from 'src/services/rtk_api/user/sessionApi';
import { userApi }              from 'src/services/rtk_api/user/UserApi';
import { contactApi }           from 'src/services/rtk_api/contact/contactApi';
import { teamsApi }             from 'src/services/rtk_api/team/TeamsApi';

const rootReducer = combineReducers({
  [bomApi.reducerPath]: bomApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [contactApi.reducerPath]: contactApi.reducer,
  [cartApi.reducerPath]: cartApi.reducer,
  [checkoutApi.reducerPath]: checkoutApi.reducer,
  [productApi.reducerPath]: productApi.reducer,
  [sessionApi.reducerPath]: sessionApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [teamsApi.reducerPath]: teamsApi.reducer
});

export default rootReducer;